import { Factory, trait } from 'miragejs';
import { VfdContactMethodKind } from 'garaje/models/vfd-contact-method';
import { faker } from '@faker-js/faker';
import { dasherize } from '@ember/string';

export default Factory.extend({
  asSlack: trait({
    kind: VfdContactMethodKind.Slack,
    metadata() {
      const id = this.channelId || faker.string.uuid();
      delete this.channelId;
      const name = this.channelName || dasherize(faker.commerce.department().toLowerCase());
      delete this.channelName;

      return {
        'channel-id': id,
        'channel-name': name,
      };
    },
  }),

  asTeams: trait({
    kind: VfdContactMethodKind.Teams,
    metadata() {
      const id = this.channelId || faker.string.uuid();
      delete this.channelId;
      const name = this.channelName || dasherize(faker.commerce.department().toLowerCase());
      delete this.channelName;

      return {
        'channel-id': id,
        'channel-name': name,
      };
    },
  }),

  asUser: trait({
    kind: VfdContactMethodKind.EnvoyUser,
    metadata: () => ({}),
  }),
});
